export const documentPaths = {
  '/documents': {
    get: {
      summary: 'List all documents',
      operationId: 'listDocuments',
      parameters: [
        {
          name: 'search',
          in: 'query',
          schema: {
            type: 'string',
          },
          description: 'Search term to filter documents by name or description',
        },
        {
          name: 'document_type_id',
          in: 'query',
          schema: {
            type: 'integer',
          },
          description: 'Filter by document type ID',
        },
        {
          name: 'document_group_ids',
          in: 'query',
          schema: {
            type: 'array',
            items: {
              type: 'integer'
            }
          },
          description: 'Filter by document group IDs',
          explode: true,
        },
        {
          name: 'publicly_available',
          in: 'query',
          schema: {
            type: 'boolean',
          },
          description: 'Filter by publicly available status',
        },
        {
          name: 'status',
          in: 'query',
          schema: {
            type: 'string',
            enum: ['active', 'expired'],
          },
          description: 'Filter by document status',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 100,
          },
          description: 'Number of items to return',
        },
        {
          name: 'offset',
          in: 'query',
          schema: {
            type: 'integer',
            default: 0,
          },
          description: 'Number of items to skip',
        },
      ],
      responses: {
        '200': {
          description: 'A list of documents',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/Document',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new document',
      operationId: 'createDocument',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/Document',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created document',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Document',
              },
            },
          },
        },
      },
    },
  },
  '/document-types': {
    get: {
      summary: 'List all document types',
      operationId: 'listDocumentTypes',
      parameters: [
        {
          name: 'search',
          in: 'query',
          schema: {
            type: 'string',
          },
          description: 'Search term to filter document types by name',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 100,
          },
          description: 'Number of items to return',
        },
        {
          name: 'offset',
          in: 'query',
          schema: {
            type: 'integer',
            default: 0,
          },
          description: 'Number of items to skip',
        },
      ],
      responses: {
        '200': {
          description: 'A list of document types',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/DocumentType',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new document type',
      operationId: 'createDocumentType',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/DocumentType',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created document type',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/DocumentType',
              },
            },
          },
        },
      },
    },
  },
  '/document-types/{id}': {
    get: {
      summary: 'Get a document type by ID',
      operationId: 'getDocumentType',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '200': {
          description: 'The requested document type',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/DocumentType',
              },
            },
          },
        },
      },
    },
    put: {
      summary: 'Update a document type',
      operationId: 'updateDocumentType',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/DocumentType',
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'The updated document type',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/DocumentType',
              },
            },
          },
        },
      },
    },
    delete: {
      summary: 'Delete a document type',
      operationId: 'deleteDocumentType',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '204': {
          description: 'Document type deleted successfully',
        },
      },
    },
  },
  '/documents/export': {
    get: {
      summary: 'Export documents as CSV',
      operationId: 'exportDocuments',
      parameters: [
        {
          name: 'search',
          in: 'query',
          schema: {
            type: 'string',
          },
          description: 'Search term to filter documents by name or description',
        },
        {
          name: 'document_type_id',
          in: 'query',
          schema: {
            type: 'integer',
          },
          description: 'Filter by document type ID',
        },
        {
          name: 'document_group_ids',
          in: 'query',
          schema: {
            type: 'array',
            items: {
              type: 'integer'
            }
          },
          description: 'Filter by document group IDs',
          explode: true,
        },
        {
          name: 'publicly_available',
          in: 'query',
          schema: {
            type: 'boolean',
          },
          description: 'Filter by publicly available status',
        },
        {
          name: 'status',
          in: 'query',
          schema: {
            type: 'string',
            enum: ['active', 'expired'],
          },
          description: 'Filter by document status',
        }
      ],
      responses: {
        '200': {
          description: 'Documents in CSV format',
          content: {
            'text/csv': {
              schema: {
                type: 'string',
                format: 'binary',
              },
            },
          },
        },
      },
    },
  },
};
